/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Unitamount1Inputs */

const en__field_unitamount1 = /** @type {(inputs: _Field_Unitamount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const de__field_unitamount1 = /** @type {(inputs: _Field_Unitamount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {_Field_Unitamount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_unitamount1 = /** @type {((inputs?: _Field_Unitamount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Unitamount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_unitamount1(inputs)
	return de__field_unitamount1(inputs)
});
export { _field_unitamount1 as "_field_unitAmount" }